import { Show, createSignal } from "solid-js";
import Modal from "./Modal";
import Text from "./Text";
import { useToast } from "./MessageBox";
import { useTranslation } from "../hooks/useTranslation";
import { canInstall, installed, isIos, promptInstall } from "../services/pwa";

export default function InstallAppButton(props: { class?: string }) {
  const toast = useToast();
  const { t } = useTranslation();
  const [iosOpen, setIosOpen] = createSignal(false);
  const [busy, setBusy] = createSignal(false);

  async function handleClick() {
    if (isIos()) {
      setIosOpen(true);
      return;
    }
    setBusy(true);
    const outcome = await promptInstall();
    setBusy(false);
    if (outcome === "unavailable") toast?.info(t("INSTALL_UNAVAILABLE"));
  }

  return (
    <Show when={!installed() && (canInstall() || isIos())}>
      <button class={props.class ?? "btn btn-primary"} onClick={() => void handleClick()} disabled={busy()}>
        <Show when={busy()} fallback={<><i class="fa-solid fa-download" /> <Text val="INSTALL_APP" /></>}>
          <i class="fa-solid fa-spinner fa-spin" />
        </Show>
      </button>

      <Modal open={iosOpen()} onClose={() => setIosOpen(false)} title={<Text val="INSTALL_IOS_TITLE" />}>
        <ol class="v" style={{ gap: "var(--spacing-md)", margin: 0, "padding-left": "var(--spacing-lg)", "font-size": "var(--font-size-sm)" }}>
          <li>
            <Text val="INSTALL_IOS_STEP1" /> <i class="fa-solid fa-arrow-up-from-bracket" style={{ opacity: 0.7 }} />
          </li>
          <li><Text val="INSTALL_IOS_STEP2" /></li>
          <li><Text val="INSTALL_IOS_STEP3" /></li>
        </ol>
      </Modal>
    </Show>
  );
}
